import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {SheetId, WorkbookId} from '@mintdata/mint-kit/api/models/Identifiers';
import {Provider} from 'mobx-react';
import * as React from 'react';

interface IMeshContextProviderProps
{
    workbookId:WorkbookId;
    sheetId:SheetId;
    isNested?:boolean;
}

export class MeshContextProvider extends React.Component<IMeshContextProviderProps, any>
{
    public render():JSX.Element
    {
        const {sheetId, isNested} = this.props;

        return (
            <Provider
                ctx={controllers.ui.spreadsheets.workbook.getMeshContextBySheetId(sheetId, isNested)}
                suppressChangedStoreWarning={true}
            >
                {this.props.children}
            </Provider>
        );
    }
}
